import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import { Col, Row } from 'reactstrap'

const HealtcareITSolutions = () => {
    const { t } = useLanguage();

    // Helper function to safely map over translation arrays
    const safeMap = (translationArray, mapFunction) => {
        if (!Array.isArray(translationArray)) {
            return [];
        }
        return translationArray.map(mapFunction);
    };
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 rightpadding8rem1 py-lg-5 py-4'>
            <Row className=''>
                <Col lg='6' className='mt-lg-5 mt-4 mb-lg-0 mb-4'>
                    <div className=''>
                        <h3 className='fs-ss-36 text-philos fw-800 text-ss-black lh-1-4' dangerouslySetInnerHTML={{ __html: (t('healthcare.healthcareITSolutions.title') || 'Healthcare IT Solutions for Doctors, Clinics and Hospitals').replace(' for ', '<br/> for ') }}>
                        </h3>
                    </div>

                    <div className='mt-lg-4'>
                        <p className='fs-ss-16 text-mulish fw-500 text-ss-black '>
                        {t('healthcare.healthcareITSolutions.content') || 'We use groundbreaking technology to get to the places that matter the most. Furthermore, we guarantee to make the most cost-effective, efficient, and professional healthcare solution service accessible. We will continue collaborating with you to provide the most effective and up-to-date services for your practice, such as.'}
                        </p>
                        <ul className='fs-ss-16 text-mulish fw-500 text-ss-black'>
                            <li className='mb-1'> {t('healthcare.healthcareITSolutions.service1')} </li>
                            <li className='mb-1'> {t('healthcare.healthcareITSolutions.service2')} </li>
                            <li className='mb-1'> {t('healthcare.healthcareITSolutions.service3')} </li>
                            <li className='mb-1'> {t('healthcare.healthcareITSolutions.service4')} </li>
                        </ul>
                    </div>
                </Col>
                <Col lg='6' className=''>
                    <div className='pe-md-0 pe-3'>
                        <img src='/healthcare/Health-Care-Image-2.webp' alt='' className='img-home-1' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default HealtcareITSolutions